<template>
    <v-row>
        <v-col cols="12">
            <base-card>
                <v-card-title class="mb-0 pb-0">
                    <div class="d-flex justify-space-between flex-wrap">
                        <v-btn
                            class="mx-2 mt-2"
                            dark
                            color="primary"
                            @click="createCompany"
                        >
                            <v-icon>mdi-plus</v-icon>
                            {{ $t('admin.companies.add') }}
                        </v-btn>
                    </div>
                </v-card-title>
                <v-card-title>
                    {{ $t('admin.companies.title') }}
                    <v-spacer />
                    <v-spacer />
                    <v-spacer />
                    <v-spacer />

                    <v-text-field
                        v-model="search"
                        :append-icon="!search ? 'mdi-magnify' : undefined"
                        clearable
                        :label="$t('common.search')"
                        single-line
                        hide-details
                    />
                </v-card-title>

                <!-- :pagination.sync="pagination" -->
                <v-data-table
                    :options.sync="options"
                    :headers="headers"
                    :footer-props="{ 'items-per-page-options': [5, 10, 30, 50, -1] }"
                    :items="items"
                    class="elevation-1"
                    :sort-by="sortby"
                    :multi-sort="true"
                    :search="search"
                    :custom-filter="filterTableItems"
                    @click:row="editItem"
                >
                    <template #item.id="{ value }">
                        <div :inner-html.prop="value | highlight(search)" />
                    </template>

                    <template #item.attributes.name="{ value }">
                        <div :inner-html.prop="value | highlight(search)" />
                    </template>

                    <template #item.attributes.title="{ value }">
                        <div :inner-html.prop="value | highlight(search)" />
                    </template>

                    <template
                        v-slot:item.attributes.logo="{ value }"
                    >
                        <!--                        {{ images[value] ? images[value] : "No image "+value }}-->
                        <div style="max-width: 250px">
                            <v-img
                                :src="getImagePath(value)"
                                height="60px"
                                contain
                                class="my-1"
                            />
                        </div>
                    </template>

                    <template #item.attributes.color-appbar="{ item }">
                        <div style="display: flex"
                             class="company--color_circles">
                            <div :style="`background-color: ${item.attributes['color-appbar']};`" />
                            <div :style="`background-color: ${item.attributes['color-background']};`" />
                            <div :style="`background-color: ${item.attributes['color-primary']};`" />
                            <div :style="`background-color: ${item.attributes['color-secondary']};`" />
                        </div>
                    </template>
                    <!--                    <template #item.attributes.color-background="{ value }">
                        <div :inner-html.prop="value | highlight(search)" />
                    </template>-->
                    <template #item.attributes.config="{ value }">
                        <div :inner-html.prop="value | highlight(search)" />
                    </template>

                    <template v-slot:item.attributes.created-at="{ value }">
                        <div :inner-html.prop="dateHelper.getDateTimeTableFormat(value)" />
                    </template>
                    <template v-slot:item.attributes.updated-at="{ value }">
                        <div :inner-html.prop="dateHelper.getDateTimeTableFormat(value)" />
                    </template>

                    <!--                    <template v-slot:item.role_id="{ item }">
    {{ itemsRoles.find((r) => r.id_role == item.role_id).name }}
</template>-->

                    <template v-slot:item.actions="{ item }">
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    small
                                    class="mr-2"

                                    v-bind="attrs"
                                    @click.stop="editItem(item)"
                                    v-on="on"
                                >
                                    mdi-pencil
                                </v-icon>
                            </template>

                            <span>{{ $t('common.edit') }}</span>
                        </v-tooltip>

                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    small
                                    v-bind="attrs"
                                    @click.stop="deleteItem(item)"
                                    v-on="on"
                                >
                                    mdi-delete
                                </v-icon>
                            </template>

                            <span>{{ $t('common.delete') }}</span>
                        </v-tooltip>
                    </template>
                    <template v-slot:no-data>
                        <v-btn
                            color="primary"
                            @click="fetchData"
                        >
                            {{ $t('admin.common.resetData') }}
                        </v-btn>
                    </template>
                </v-data-table>
            </base-card>

            <confirm-dialog
                ref="confirm"
            />
        </v-col>
    </v-row>
</template>

<script>
import axios from '@/plugins/axios';

import ConfirmDialog from '@/components/common/ConfirmDialog';
import { debounce } from "debounce";

import CompaniesAPIService from "@/services/CompaniesAPIService";

export default {
    components: { /* RoleCreate, */ ConfirmDialog },
    data: function () {
        return {
            urlMain: '/companies',
            /* dialog: false, */
            headers: [
                {
                    text: 'Id',
                    align: 'start',
                    sortable: true,
                    value: 'id'
                },
                {
                    text: this.$t('admin.companies.name'),
                    value: 'attributes.name'
                },
                {
                    text: this.$t('admin.companies.title'),
                    value: 'attributes.title'
                },
                {
                    text: this.$t('admin.companies.logo'),
                    value: 'attributes.logo'
                },
                {
                    text: this.$t('admin.companies.colors'),
                    value: 'attributes.color-appbar'
                },
                {
                    text: this.$t('admin.common.createdAt'),
                    value: 'attributes.created-at'
                },
                {
                    text: this.$t('admin.common.updatedAt'),
                    value: 'attributes.updated-at'
                },
                // { text: "Role", value: "role_id" },
                {
                    text: this.$t('admin.common.actions'),
                    value: 'actions',
                    sortable: false
                }
            ],
            search: '',
            items: [],
            itemSelected: null,
            sortby: ['id'],
            options: {
                itemsPerPage: 5
            }
        };
    },
    watch: {
        dialog(val) {
            val || this.close();
        }
    },

    created() {
        this.fetchData();
    },

    mounted() {

    },

    methods: {
        fetchData: debounce(function (e) {
            this.fetchDataFinal(e);
        }, 500),

        async fetchDataFinal(data = this.options) {
            try {
                const controller = new AbortController();
                const signal = controller.signal;

                const result = await CompaniesAPIService.getCompanies({signal});

                this.initialize(result.data);
            } catch (e) {
                if (e.name !== 'TypeError')
                    this.$store.dispatch('snackbar/error', this.$t('common.errorLoadingData'));
            }
        },
        initialize($data) {
            this.items = $data.data ?? [];

            // this.pagination.totalItems = $data?.meta?.page?.total ?? 0;
        },
        createCompany() {
            this.$router.push('/app/admin/companies/create/new');
        },
        /* setRole($data) {
      this.itemsRoles = $data;
  }, */
        editItem(item) {
            // this.itemSelected = item;
            // this.dialog = true;

            this.$router.push({ name: 'CompaniesCreate', params: { item, id: item.id + '' } });
        },
        async deleteItemConfirmed(item) {
            const urlAppend = item.id ? '/' + item.id : '';

            try {
                const result = await axios
                    .delete(this.urlMain + urlAppend);

                if (result.status === 200 || result.status === 204) {
                    this.fetchData();
                    // snackbar/
                    this.$store.dispatch('snackbar/success', this.$t('common.deleteOK'));
                }
            } catch (error) {
                this.$store.dispatch('snackbar/error', this.$t('common.accionError'));

                /* if (error.response) {
                    console.log(error.response.data.error) // "invalid_credentials"
                    console.log(error.response.status)
                    console.log(error.response.headers)
                } */
            }
            this.$store.dispatch('loading/end');
        },
        async deleteItem(item) {
            if (
                await this.$refs.confirm.open(
                    this.$t('common.confirmTitle'),
                    this.$t('common.confirmMSGDelete')
                )
            ) {
                this.deleteItemConfirmed(item);
            }
        },

        close() {
            this.dialog = false;
            this.$nextTick(() => {
                this.itemSelected = null;
            });
        },
        filterTableItems(value, search, item) {
            // console.log("filterTableItems", value);
            let filter = false;
            if (value != null &&
                search != null) {
                if (typeof value === 'string') {
                    if (value === item.created_at || value === item.updated_at) {
                        filter = this.dateHelper.getDateTimeTableFormat(value).includes(search);
                    } else { filter = value.toString().toLocaleUpperCase().indexOf(search.toLocaleUpperCase()) !== -1; }
                } else if (typeof value === 'number') {
                    if (value == search) {
                        filter = true;
                    } else {
                        filter = (value + '').indexOf(search) !== -1;
                    }
                }
            }

            return filter;
        },
        getImagePath(image) {
            return image ? process.env.VUE_APP_API_ENDPOINT + 'media/imagesSimple?filename=companies/images/' + image : '';
        }
    },
    computed: {

    }
};
</script>

<style lang="scss">
.company--color_circles > div{
    width:20px;
    height: 20px;
    border-radius: 50%;
}
</style>
